import React from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";

const AcceptPopUp = ({
  open,
  onCancel,
  onOk,
  notOk,
  title,
  statusType,
  okButtonText,
  isRequiredCancelButton = true,
  cancelButtonText,
  isRequiredTitle = true,
  isRequiredStatus = true,
  width = 400,
  isRequiredColor,
}) => {
  return (
    <div>
      <DiaglogBox open={open} onCancel={onCancel} width={width}>
        {isRequiredColor === "green" ? (
          <div className="relative">
            <div className="flex justify-center items-center absolute top-0 left-0 w-full h-full">
              <img src="/images/greentick.svg" alt="" />
            </div>
            <div className="w-full h-1/3">
              <img src="/images/greenBg.svg" alt="" className="w-full" />
            </div>
          </div>
        ) : isRequiredColor === "red" ? (
          <div className="relative">
            <div className="flex justify-center items-center absolute top-0 left-0 w-full h-full">
              <img src="/images/redTick.svg" alt="" />
            </div>
            <div className="w-full h-1/3">
              <img src="/images/redBg.svg" alt="" className="w-full" />
            </div>
          </div>
        ) : (
          <div className="relative">
            <div className="flex justify-center items-center absolute top-0 left-0 w-full h-full">
              <p className="font-bold text-2xl">Notification</p>
            </div>
            <div className="w-full h-1/3">
              <img src="/images/purpleBg.svg" alt="" className="w-full" />
            </div>
          </div>
        )}
        <div className="text-center py-3">
          {isRequiredTitle && (
            <p className="text-center text-lg font-medium">{title}</p>
          )}
          {isRequiredStatus &&
          (isRequiredColor === "green" || isRequiredColor === "red") ? (
            <p
              className={`text-center px-8 text-[10px] font-light pt-2 ${
                isRequiredColor === "green" ? "text-bold" : ""
              }`}
            >
              {statusType}
            </p>
          ) : (
            <p className="text-center font-normal text-xs px-8 pt-2">
              {statusType}
            </p>
          )}
          <div className="flex justify-center gap-x-4 pt-4 py-2">
            <Button
              varient="primary"
              color="blue"
              className="w-[9rem] h-[2.5rem] text-sm py-2 text-white font-bold"
              onClick={onOk}
            >
              {okButtonText}
            </Button>

            {isRequiredCancelButton && (
              <Button
                varient="primary"
                borderColor={"blue"}
                color="white"
                onClick={notOk}
                className="w-[9rem] h-[2.5rem] text-sm text-blue-800 font-bold border-[1px]"
              >
                {cancelButtonText}
              </Button>
            )}
          </div>
        </div>
      </DiaglogBox>
    </div>
  );
};

export default AcceptPopUp;
